module.exports = __webpack_public_path__ + "d7341b8437017ef5914a88d9a14a3239.png";


//////////////////
// WEBPACK FOOTER
// ./vue/images/default-avatar.png
// module id = 803
// module chunks = 0